import { useEffect, useState, useSyncExternalStore } from "react";
import { getSharedPublic } from "@/lib/api";
import { PREVIEW_MESSAGE, PREVIEW_READY, PREVIEW_APPLIED, previewSession } from "@/theme/previewProtocol";

export { PREVIEW_MESSAGE, PREVIEW_READY, PREVIEW_APPLIED, previewSession };
let drafts = {};
const listeners = new Set();
let listening = false;

function receive(event) {
  const session = previewSession();
  if (!session || event.origin !== window.location.origin || event.source !== window.parent ||
      event.data?.type !== PREVIEW_MESSAGE || event.data.session !== session ||
      !event.data.configs || typeof event.data.configs !== "object") return;
  drafts = event.data.configs;
  listeners.forEach((notify) => notify());
  window.parent.postMessage({ type: PREVIEW_APPLIED, session, path: window.location.pathname }, window.location.origin);
}

function subscribe(notify) {
  if (!previewSession()) return () => {};
  listeners.add(notify);
  if (!listening) {
    window.addEventListener("message", receive);
    listening = true;
  }
  // Every newly mounted page can request the current draft, also after navigation.
  window.parent.postMessage({ type: PREVIEW_READY, session: previewSession(), path: window.location.pathname }, window.location.origin);
  return () => {
    listeners.delete(notify);
    if (!listeners.size) {
      window.removeEventListener("message", receive);
      listening = false;
      drafts = {};
    }
  };
}
const emptyDrafts = {};

/** A preview draft is local to the embedded editor. Regular visitors fetch saved config. */
export default function useThemeConfig(page, fallback) {
  const [saved, setSaved] = useState(fallback);
  const preview = useSyncExternalStore(subscribe, () => drafts, () => emptyDrafts);
  useEffect(() => {
    let active = true;
    getSharedPublic(`/theme/${page}`).then(({ data }) => {
      if (active && data?.config && typeof data.config === "object") setSaved(data.config);
    }).catch(() => {});
    return () => { active = false; };
  }, [page]);
  return Object.prototype.hasOwnProperty.call(preview, page) ? preview[page] : saved;
}
